export const sum = (list = []) => list.reduce((a, b) => a + b, 0);
//# sourceMappingURL=sum.js.map